import { getPropertyValue } from '../../tools/dom/css-properties'

// The y domain is defined as 0-255 and is split in the middle.
// We add 10 on both sides to avoid cropping at the edges.
const GRAPH_Y_BOUNDARY_OFFSET = 10
export const GRAPH_SIZE = 255
export const GRAPH_HALF_SIZE = 127.5
export const GRAPH_AXIS_BYTE_RANGE = [
    0 - GRAPH_Y_BOUNDARY_OFFSET,
    GRAPH_HALF_SIZE,
    GRAPH_SIZE + GRAPH_Y_BOUNDARY_OFFSET,
]
export const GRAPH_LAYOUT_COLOR = '#E5E7EB'
export const GRAPH_LINE_STYLE = { stroke: GRAPH_LAYOUT_COLOR, strokeWidth: 0.5 }
export const GRAPH_BORDER_STYLE = { stroke: GRAPH_LAYOUT_COLOR, strokeDasharray: '4,4' }
export const GRAPH_DEFAULT_DOT_STROKE = 2
export const GRAPH_DEFAULT_DOT_RADIUS = 6
export const GRAPH_STROKED_DOT_RADIUS = 5

// Dynamic getters for css properties respecting theme selection.
export const getGraphBackgroundColor = () => getPropertyValue('--elevated-surface')
export const getGraphPrimaryColor = () => getPropertyValue('--primary-color')
export const getGraphStrokeColor = () => getPropertyValue('--primary-light-color')
export const getGraphOverlayColor = () => getPropertyValue('--emphasis-color')
export const getGraphSecondaryColor = () => getPropertyValue('--action-color')
